import { takeLatest, put, all, call } from "redux-saga/effects";
import { encryptData } from "../../_common/enode-decode";
import {
  callbackExportAllChanged,
  callbackExportAllFailure,
  callbackExportAllSuccess,
  callbackFetchAllChanged,
  callbackFetchAllFailure,
  callbackFetchAllSuccess,
} from "./callBack.action";
import CallBackTypes from "./callBack.types";
import { fetchAllCallback, ComonExportPage } from "./callBack.services"; //exportAllCallback,

/** *********************** SATRT CALL BACK SHOW  LIST ************************ */
export function* callbackListFetch({ payload }: any) {
  const key: any = "CallBackKey";
  try {
    const jsonData: any = {
      UserID: payload.UserID,
      CompanyID: payload.CompanyID,
      AgentID: payload.AgentID,
      //   UserType: payload.UserType,
      UserTypeName: payload.UserTypeName,
      CallBackFromDate: payload.CallBackFromDate,
      CallBackToDate: payload.CallBackToDate,
      Dispositon: payload.Dispositon,
      PhoneNumber: payload.PhoneNumber,
      Limit: payload.Limit,
      InstanceName: payload.InstanceName,
      BranchID: payload.BranchID,
      // ISSUE-009: server-side page size (10/25/50 selector)
      RowsPerPage: payload.RowsPerPage ?? 10,
    };
    const fetchData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(fetchAllCallback, fetchData);
    if (responseData.data.statusCode === "100") {
      yield put(callbackFetchAllFailure(responseData.data));
    } else {
      yield put(callbackFetchAllSuccess(responseData.data));
    }
  } catch (error) {
    yield put(callbackFetchAllFailure(error));
  }
}
export function* callbackFetchAllDataReset() {
  yield put(callbackFetchAllChanged());
}
export function* onFetchListCallback() {
  yield takeLatest(CallBackTypes.CALLBACK_FETCH_START, callbackListFetch);
}
export function* onCallbackReset() {
  yield takeLatest(
    CallBackTypes.CALLBACK_FETCH_RESET_START,
    callbackFetchAllDataReset,
  );
}
/************************* END CALL BACK FETCH ALL  LIST ************************ */

/** *********************** SATRT CALL BACK EXPORT  LIST ************************ */
export function* callbackListExport({ payload }: any) {
  const key: any = "CreateRequestReportKey";
  try {
    const jsonData: any = {
      BranchID: payload.BranchID,
      IsFresh: payload.IsFresh,
      ConditionExec: payload.ConditionExec,
      ExistRequestID: 1,
      CreateDateTime: payload.CreateDateTime,
      RequestReportPage: payload.RequestReportPage,
      CompanyID: payload.CompanyID,
      RequestedBy: payload.RequestedBy,
      URL: payload.URL,
      FromDate: payload.FromDate,
      ToDate: payload.ToDate,
      MemberID: payload.MemberID,
      DateType: payload.DateType,
      InstanceName: payload.InstanceName,
    };
    const fetchData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(ComonExportPage, fetchData);
    if (responseData.data.statusCode === "100") {
      yield put(callbackExportAllFailure(responseData.data));
    } else {
      yield put(callbackExportAllSuccess(responseData.data));
    }
  } catch (error) {
    yield put(callbackExportAllFailure(error));
  }
}
export function* callbackExportAllReset() {
  yield put(callbackExportAllChanged());
}
export function* onExportListCallback() {
  yield takeLatest(CallBackTypes.CALLBACK_EXPORT_START, callbackListExport);
}
export function* onCallbackExportReset() {
  yield takeLatest(
    CallBackTypes.CALLBACK_EXPORT_RESET_START,
    callbackExportAllReset,
  );
}
/************************* END CALL BACK EXPORT ALL  LIST ************************ */
export function* callbackSaga() {
  yield all([
    call(onCallbackReset),
    call(onFetchListCallback),
    call(onExportListCallback),
    call(onCallbackExportReset),
  ]);
}
